import moment from "moment";
import axios from "../../../Axios/axiosConfig";
import { mapCipDataToStandardFormat, validateCipData } from "./CipDataMapper";

export class CipAnalyticsService {
  baseUrl;

  constructor(serverUrl) {
    this.baseUrl = serverUrl || "";
  }

  async getCipAnalyticsData(startDate, endDate, selectedProductionLineId) {
    const from = moment(startDate).toISOString();
    const to = moment(endDate).toISOString();
    const url = `${this.baseUrl}/production-lines/beverages/${selectedProductionLineId}/cip-analytics/data`;

    try {
      const res = await axios.get(url, {
        params: {
          from,
          to,
        },
      });

      const rawData = res?.data;
      if (!rawData) {
        throw new Error("Empty response data");
      }

      const mappedData = mapCipDataToStandardFormat(rawData);
      const validationErrors = validateCipData(mappedData);

      if (validationErrors.length > 0) {
        console.warn("Data validation warnings:", validationErrors);
      }

      return {
        data: mappedData,
        originalData: rawData,
      };
    } catch (err) {
      // Re-throw with more context if needed
      throw new Error(`Failed to fetch CIP analytics data: ${err.message}`);
    }
  }

  async getCipAnalyticsTotals(startDate, endDate, selectedProductionLineId) {
    const from = moment(startDate).toISOString();
    const to = moment(endDate).toISOString();

    const url = `${this.baseUrl}/production-lines/beverages/${selectedProductionLineId}/cip-analytics/totals`;

    try {
      const res = await axios.get(url, {
        params: {
          from,
          to,
        },
      });

      // Check for duplicate cipIds in the response
      const cipIds = res.data.map((item) => item.cipId);
      const uniqueCipIds = [...new Set(cipIds)];

      if (cipIds.length !== uniqueCipIds.length) {
        console.warn("Duplicate cipIds detected in response!");
      }

      return res?.data || [];
    } catch (err) {
      throw new Error(`Failed to fetch CIP totals data: ${err.message}`);
    }
  }
}
